import './TrademarkApplicationsListItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function TrademarkApplicationsListItem({user, applicationItem, isMobile}) {

    return (
    <tr className='TrademarkApplicationsListItem'>
        <td className='RPNumber'>
            {applicationItem.RPNumber? 
            <div>
                {applicationItem.RPNumber}
            </div>
            :
            '---'
            }
        </td>
        <td className='applicationNumber'>
            {applicationItem.applicationNumber? applicationItem.applicationNumber:'---'}
        </td>
        <td className='applicationType'>
            {applicationItem.applicationType? capitalizeFirstLetter(applicationItem.applicationType):'---'}
        </td>
        <td className='trademarkType'>
            {applicationItem.trademarkType? capitalizeFirstLetter(applicationItem.trademarkType):'---'}
        </td>
        <td className='filingDate dateField'>
            <div>
                {applicationItem.filingDate? new Date(applicationItem.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        <td className='trademarkDescription'>
            <div>
                {applicationItem.trademarkDescription? applicationItem.trademarkDescription:'---'}
            </div>
        </td>
        <td className='applicationStatus'>
            <div>
                {applicationItem.applicationStatus? 
                <>
                {applicationItem.applicationStatus === 'officeActionIssued'? 'Office Action Issued' : applicationItem.applicationStatus === 'awaitingExam'? 'Awaiting Examination' : applicationItem.applicationStatus === 'examReportIssued'? 'Examination Report Issued' : applicationItem.applicationStatus === 'NOAIssued'? 'NOA Issued' : capitalizeFirstLetter(applicationItem.applicationStatus)}
                </>
                :
                '---'
                }
            </div>
        </td>
        <td className='trademarkClasses'>
            {applicationItem.trademarkClasses? applicationItem.trademarkClasses:'---'}
        </td>
        <td className='filing'>
            {applicationItem.filing? 
            <>
            {applicationItem.filing === 'useInCommerce' ? 'Use In Commerce' : applicationItem.filing === 'intentToUse' ? 'Intent To Use' : applicationItem.filing === 'baseApplication' ? 'Base Application' : applicationItem.filing === 'foreignPriority' ? 'Foreign Priority' : applicationItem.filing === 'foreignRegistration' ? 'Foreign Registration' : applicationItem.filing === 'internationalFiling' ? 'International Filing' : capitalizeFirstLetter(applicationItem.filing)}
            </>
            :
            '---'
            }
        </td>
        <td className='registrationNumber'>
            <div>
                {applicationItem.registrationNumber? applicationItem.registrationNumber:'---'}
            </div>
        </td>
        <td className='nextAction'>
            <div>
                {applicationItem.nextAction? applicationItem.nextAction:'---'}
            </div>
        </td>
        <td className='nextActionDueDate dateField'>
            <div>
                {applicationItem.nextActionDueDate? new Date(applicationItem.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
    </tr>
  )
}
